import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import {
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  EditProductTableSuccess,
} from "../../Redux/Actions/InputData";
import {
  API_BASE_URL,
  DISPLAY_OEE_CPT_FILTERS_API,
  DOWNLOAD_OEE_CPT_TABLE_API,
  NEW_EDIT_OEE_CPT_TABLE_API,
  VIEW_OEE_CPT_TABLE_API,
} from "../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import OEEAndCPTTables from "./OEEAndCPTTables";
import btnDownloadIcon from "./../../Assests/download.svg";
import { postRequest, putRequest } from "../../Services/AxiosConfiguration";
import axios from "axios";
import FileSaver from "file-saver";
import * as actions from "../../Redux/Actions/index";
import ErrorOrWarningDialog from "../../Components/Modals/ErrorOrWarningDialog";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import btnSaveIcon from "./../../Assests/Save-btn.svg";

import AddRowButton from "../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../Components/Common/ConfirmationDialog";

function OEEAndCPTInputs(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [selectRMPMDescription, setSelectRMPMDescription] = useState("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [descriptionOptions, setDescriptionOptions] = useState<any>([]);
  // const [filterRequest, setFilterRequest] = React.useState([]);
  // const [filterRequest, setFilterRequest] = React.useState([{"key": "Factory_Name", "value": ""}, {"key": "RM_PM_Description", "value": ""}]);
  const [filterRequest, setFilterRequest] = React.useState([
    { key: "factory", value: "" },
    { key: "line", value: "" },
    { key: "basepack", value: "" },
    { key: "time_period", value: "" },
  ]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const sortedFactoryNames = factoryOptions.sort((a: any, b: any) =>
    a?.factory_Name.localeCompare(b?.factory_Name),
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  const {
    isErrorDialog,
    errorMessage,
    isErrorOrWarningDialog,
    errorOrWarningMessage,
  } = useSelector((state: any) => state.InputDataReducers);

  var line = 0;
  var base = 0;
  var time = 0;

  /**Redux state */
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );
  /** Redux may store a number or the full scenario object (avoids "[object Object]" in API URLs) */
  const resolvedScenarioId =
    selectedScenarioId != null &&
    typeof selectedScenarioId === "object" &&
    !Array.isArray(selectedScenarioId)
      ? (selectedScenarioId as any).scenario_id ??
        (selectedScenarioId as any).scenarioId
      : selectedScenarioId;
  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  useEffect(() => {
    if (
      selectedUsecaseId === undefined ||
      selectedCategoryId === undefined ||
      selectedFolderId === undefined ||
      selectedScenarioId === undefined
    ) {
    } else {
      //setPageIsLoaded(false);
    }
    // callTableGridApi();
  }, []);

  // useEffect(() => {
  //   callTableGridApi();
  // }, []);
  useEffect(() => {
    callTableGridApi();
    getfiltersApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);

  const callTableGridApi = (resetfilter?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "ispagination": 1, "page": 1, "pagesize": 100, "filter": resetfilter ? resetfilter : filterList };
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: resolvedScenarioId,
      table: resolvedScenarioId === 0 ? "tblOEECPT" : "tblScenario_OEECPT",
      time_period: timePeriodValues,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: resetfilter ? resetfilter : filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + VIEW_OEE_CPT_TABLE_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "dateaaa");
          setIsProcessed(true);
          setRows(response.data);
          if (factoryOptions.length === 0)
            setFactoryOptions(actions.loadFactoryOptions(response.data));
          if (line === 0)
            setLineOptions(actions.loadLineOptions(response.data));
          if (base === 0)
            setBasepackOptions(actions.loadBasePackOptions(response.data));
          if (time === 0)
            setTimePeriodOptions(actions.loadTimePeriodOptions(response.data));
          // loadFactoryOptions(response.data);
          // loadLineOptions(response.data);
          // loadBasePackOptions(response.data);
          // loadTimePeriodOptions(response.data);
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };
  const loadFactoryOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.factory_Name === item.factory;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({ id: item.id, factory_Name: item.factory });
      }
    });
    setFactoryOptions(factoryOptions);
  };

  const loadLineOptions = (data: any) => {
    const lineOptions: any = [];
    data.map((item: any) => {
      const filteredItem = lineOptions.find((obj: any) => {
        return obj.line === item.line;
      });
      if (filteredItem === undefined || filteredItem == null) {
        lineOptions.push({ id: item.id, line: item.line });
      }
    });
    setLineOptions(lineOptions);
  };

  const loadBasePackOptions = (data: any) => {
    const basePackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = basePackOptions.find((obj: any) => {
        return obj.basepack === item.basepack;
      });
      if (filteredItem === undefined || filteredItem == null) {
        basePackOptions.push({ id: item.id, basepack: item.basepack });
      }
    });
    setBasepackOptions(basePackOptions);
  };

  const loadTimePeriodOptions = (data: any) => {
    const timePeriodPackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodPackOptions.find((obj: any) => {
        return obj.time_period === item.time_period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodPackOptions.push({
          id: item.id,
          time_period: item.time_period,
        });
      }
    });
    return timePeriodPackOptions;
    //console.log(timePeriodOptions, "timePeriodOptions")
    // console.log(timePeriodPackOptions, "timePeriodPackOptions")
    // setTimePeriodOptions(timePeriodPackOptions);
  };

  const getfiltersApi = () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: resolvedScenarioId,
      table: resolvedScenarioId === 0 ? "tblOEECPT" : "tblScenario_OEECPT",
      time_period: timePeriodValues,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + DISPLAY_OEE_CPT_FILTERS_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setFactoryOptions(response.data.factory_NameFilter);
          setDescriptionOptions(response.data.rM_PM_DescriptionFilter);
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const handleChangeSelectFactory = (event: any) => {
    setSelectBasepack("");
    setSelectLine("");
    setSelectTimePeriod("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    filterRequest[0].value = value;
    callTableGridApi();
    line = 0;
  };

  // const handleChangeSelectDescription = (event: any) => {
  //   const { target: { value } } = event;
  //   setSelectRMPMDescription(value);
  //   callTableGridApi();
  // };

  const handleChangeSelectLine = (event: any) => {
    setSelectBasepack("");
    setSelectTimePeriod("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setSelectLine(value);
    filterRequest[1].value = value;
    callTableGridApi();
    line = 1;
    base = 0;
    time = 0;
  };

  const handleChangeSelectBasepack = (event: any) => {
    setSelectTimePeriod("");
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setSelectBasepack(value);
    filterRequest[2].value = value;
    callTableGridApi();
    line = 1;
    base = 1;
    time = 0;
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectTimePeriod(value);
    filterRequest[3].value = value;
    callTableGridApi();
    line = 1;
    base = 1;
    time = 1;
  };

  const handleRestoreClicked = (e: any) => {
    setSelectFactory("");
    setSelectBasepack("");
    setSelectLine("");
    setSelectTimePeriod("");
    setSelectRMPMDescription("");
    filterRequest.filter((element) => element.value != "");
    callTableGridApi([]);
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    // filterRequest[4].value = "";
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblSourcingData", "filter": filterList };
    const requestParam = {
      usecaseId: selectedUsecaseId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: resolvedScenarioId,
      table: resolvedScenarioId === 0 ? "tblOEECPT" : "tblScenario_OEECPT",
      time_period: timePeriodValues,
      filter: filterList,
    };
    const urls = API_BASE_URL + DOWNLOAD_OEE_CPT_TABLE_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  console.log(timePeriodOptions, "timeoptions");

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "factory_Code",
      "factory",
      "format",
      "cascade",
      "line",
      "pack",
      "basepack_Code",
      "basepack",
      "time_period",
      "oee",
      "conversion_Cost_per_Tonne",
    ];

    // Collect all unique missing fields across all rows
    const allMissingFields = new Set<string>();
    console.log(getEditedValue, "getEditedValue");
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    console.log(allMissingFields, "allMissingFields");
    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: resolvedScenarioId,
        factory_Code: "",
        factory: "",
        format: "",
        cascade: "",
        line: "",
        pack: "",
        basepack_Code: "",
        basepack: "",
        time_period: "",
        oee: 0,
        conversion_Cost_per_Tonne: 0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
    setTimeout(() => {
      childRef.current?.goToLastPage?.();
    }, 0);
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const message = successMessage || "Successfully saved";
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        rest.usecaseId = selectedUsecaseId;
        rest.category_Id = selectedCategoryId;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls =
      API_BASE_URL +
      NEW_EDIT_OEE_CPT_TABLE_API +
      `?ScenarioId=${resolvedScenarioId}`;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    putRequest(urls, transformedRows, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: message,
            severity: "success",
          });
          handleClose();
          //dispatch(enableEditFilter(false, "handlecat"));
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        // dispatch(enableEditFilter(false, "handlecat"));
        handleClose();
      });
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited OEE and CPT table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="OEE & CPT Inputs"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      {isErrorOrWarningDialog && (
        // eslint-disable-next-line react/jsx-no-undef
        <ErrorOrWarningDialog
          isErrorOrWarningDialog={isErrorOrWarningDialog}
          errorOrWarningMessage={errorOrWarningMessage}
        />
      )}
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>OEE & CPT</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Factory</em>
                  </MenuItem>
                  {sortedFactoryNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.factory_Name}>
                        {d.factory_Name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Line</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectLine}
                  placeholder="Select Line"
                  onChange={handleChangeSelectLine}
                  // renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Line</em>
                  </MenuItem>
                  {lineOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.line}>
                        {d.line}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Basepack</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectBasepack}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectBasepack}
                  // renderValue={(selectBasepack: any) => selectBasepack}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Basepack</em>
                  </MenuItem>
                  {basepackOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.basepack}>
                        {d.basepack}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>TimePeriod</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTimePeriod}
                  placeholder="Select TimePeriod"
                  onChange={handleChangeSelectTimePeriod}
                  // renderValue={(selectTimeperiod: any) => selectTimeperiod}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>TimePeriod</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}
            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={handleDownload}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <OEEAndCPTTables
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          ref={childRef}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default OEEAndCPTInputs;
